import { CdkAccordionModule } from '@angular/cdk/accordion';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BytesizeIconPipe } from '@portal/pipe';
import { MegaMenuItem } from './mega-menu-item.interface';

@Component({
  selector: 'portal-ui-mega-menu-item',
  standalone: true,
  imports: [NgIf, NgClass, NgForOf, CdkAccordionModule, BytesizeIconPipe],
  templateUrl: './mega-menu-item.component.html',
  styles: [':host {@apply block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegaMenuItemComponent {
  @Input() menuItems: MegaMenuItem[] = [];
  protected readonly cimbUrl = 'https://www.cimb.com.sg';
}
